export default __webpack_public_path__ + "static/blob3-a3a6d5698a3b74a0b7af9b0af101692c.svg";